import { create } from 'zustand';

interface EditorState {
  currentPhase: 0 | 1 | 2 | 3 | 4;
  hasUnsavedChanges: boolean;
  lastSaved: Date | null;
  isSaving: boolean;
  setPhase: (phase: 0 | 1 | 2 | 3 | 4) => void;
  markDirty: () => void;
  markSaved: () => void;
  setIsSaving: (saving: boolean) => void;
  reset: () => void;
}

const initialState = {
  currentPhase: 0 as const,
  hasUnsavedChanges: false,
  lastSaved: null,
  isSaving: false,
};

export const useEditorStore = create<EditorState>((set) => ({
  ...initialState,

  setPhase: (phase) => set({ currentPhase: phase }),

  markDirty: () => set({ hasUnsavedChanges: true }),

  markSaved: () =>
    set({ hasUnsavedChanges: false, lastSaved: new Date(), isSaving: false }),

  setIsSaving: (saving) => set({ isSaving: saving }),

  reset: () => set(initialState),
}));
